module.exports = __webpack_public_path__ + "img/Muzemix_Banner_LoggedOut.bb1cf301.png";